<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-12 21:20 -->
<!-- Description:  -->
<template>
  <div>
    <RoleForm @saved="afterSave($event)"></RoleForm>
  </div>
</template>
<script>
import RoleForm from "./RoleForm.vue";
// script content
export default {
  name: "RoleCreateView",
  components: {
    RoleForm
  },

  // directives

  props: {
    //
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    afterSave() {
      this.$router.push({
        name: "admin.role-list",
      })
    }
    //
    //
  }
};
</script>
<style scoped></style>

